import React, { memo, useCallback, useEffect, useState } from 'react';
//   import Modal from 'react-responsive-modal';
// import '@style/components/dropdown.scss';
import '../../styles/components/dropdown.scss';
import AccessIndicator from '@components/accessIndicator';

function Dropdown({ title, list, permission, sendData }) {
  const [open, setOpen] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(title);

  useEffect(() => {
    setCurrentTitle(title);
  }, [title]);

  const handleDropdownChange = useCallback(
    (event, id) => {
      event.nativeEvent.stopImmediatePropagation();
      setCurrentTitle(list?.find((i) => i.id === id)?.title || '');
      setOpen(false);
      sendData(id, false);
    },
    [list, sendData],
  );

  useEffect(() => {
    const closeDropdown = (e) => {
      setOpen(false);
    };
    document.addEventListener('click', closeDropdown);

    return () => {
      document.removeEventListener('click', closeDropdown);
    };
  }, []);

  const toggleOpen = (event) => {
    event.nativeEvent.stopImmediatePropagation();
    setOpen(!open);
  };

  return (
    <div className="dd-wrapper">
      <div className="row dd-header">
        <div className="dd-header-title" onClick={toggleOpen}>
          {currentTitle}
        </div>
        <div className="dd-header-icon" onClick={toggleOpen}>
          {open ? (
            <span className="appkiticon icon-up-chevron-fill" />
          ) : (
            <span className="appkiticon icon-down-chevron-fill" />
          )}
        </div>
        <AccessIndicator page={permission} />
      </div>

      {open && (
        <div className="dropdownModal">
          {list.map((item) => (
            <div
              className="dd-list-item"
              style={{ padding: '0.625rem', cursor: 'pointer' }}
              key={item.id}
              onClick={(e) => handleDropdownChange(e, item.id)}
            >
              {item.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(Dropdown);
